<template>
  <div class="icon">
    <component :is="product.logo" v-bind="product.iconProps" v-if="props.showLogo" />
  </div>
  <h2 class="heading-medium">
    {{ headingText }}
  </h2>
  <heading-chip />
</template>

<script setup>
import { watch, computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useProduct } from 'ihunter-pathfinder-components';
import HeadingChip from './HeadingChip.vue';

const { product } = useProduct();
const { t } = useI18n();

const props = defineProps({
  heading: {
    type: String,
    default: '',
  },
  showLogo: {
    type: Boolean,
    default: true
  }
});

const headingText = computed(() => {
  return props.heading || t(`product.${product.value.name}.title`);
});

</script>

<style lang="scss" scoped>
@use 'ihunter-pathfinder/styles' as Pathfinder;
@use '../styles/Header' as Header;

div {
  @include Header.Style;
}
</style>